import React, { useState, useRef, useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';

const PayrollCtcSidebar = ({ setIsOffCanvasOpenCtc, isOffCanvasOpenCtc }) => {
    const sidebarRef = useRef(null);

    // Function to handle clicks outside the sidebar
    const handleClickOutside = (event) => {
        if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
            setIsOffCanvasOpenCtc(false);
        }
    };

    useEffect(() => {
        if (isOffCanvasOpenCtc) {
            // Attach the event listener when the sidebar is open
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            // Remove the event listener when the sidebar is closed
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            // Cleanup the event listener on unmount
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOffCanvasOpenCtc]);

    const sampleData = {
        month: 'November',
        year: 2024,
        employeeName: 'Kanika Aroa',
        totalSalary: 13333.34,
        earnings: [{ label: 'Basic Salary', amount: 7166.67 }],
        contribution: [
            { label: 'Employer PF', value: 'None' },
            { label: 'Employer ESI', value: 'None' },
            { label: 'Employer LWF', value: 'Arunachal Pradesh' },
            { label: 'PF EDLI & Admin Charges', value: 'None' },
        ],
        deductions: [
            { label: 'Employer PF', value: 'None' },
            { label: 'Employer ESI', value: 'None' },
            { label: 'Employer LWF', value: 'Arunachal Pradesh' },
            { label: 'Professional Tax', value: 'None' },
        ],
    };

    return (
        <div
            ref={sidebarRef}
            className={`fixed top-[56px] right-0 h-screen sm:w-[400px] w-full z-[99] shadow-cs bg-white payroll-sidebar shadow-lg transform transition-transform duration-300 ${
                isOffCanvasOpenCtc ? 'translate-x-0' : 'translate-x-full'
            }`}
        >
            <div className="relative w-full h-full">
                <div className="flex justify-between items-center border-gray-200 p-4 border-b">
                    <h2 className="font-semibold text-[#000] text-[18px]">Piyush</h2>
                    <button
                        className="text-[black]"
                        onClick={() => setIsOffCanvasOpenCtc(false)}
                    >
                        <CloseIcon />
                    </button>
                </div>
                <div className="relative z-[1] bg-red mb-[10px] p-[10px] pb-[20px] w-full max-w-md h-[82%] overflow-y-scroll">
                    <div className="flex justify-between items-center bg-[#e5e7eb3b] mb-[10px] p-[10px] w-full">
                        <p className="font-normal text-muted-foreground text-sm">Ctc</p>
                        <p className="pr-[10px] font-normal text-muted-foreground text-sm">
                            ₹ {sampleData.totalSalary.toFixed(2)}
                        </p>
                    </div>

                    {/* Earnings Section */}
                    <div className="mb-[10px] border-b">
                        <button className="flex justify-between items-center bg-[#e5e7eb3b] p-[10px] w-full">
                            <span className="font-normal text-muted-foreground text-sm">Earnings</span>
                        </button>
                        <div className="overflow-hidden">
                            {sampleData.earnings.map((item, index) => (
                                <div
                                    key={index}
                                    className="flex justify-between items-center px-[20px] py-2 pb-[10px] border-b text-sm"
                                >
                                    <span className="font-light text-muted-foreground">{item.label}</span>
                                    <div className="flex items-center gap-2">
                                        <span className="font-light">₹ {item.amount.toFixed(2)}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Contribution Section */}
                    <div className="mb-[10px]">
                        <button className="flex justify-between items-center bg-[#e5e7eb3b] p-[10px] w-full">
                            <span className="font-normal text-muted-foreground text-sm">
                                Employer Contribution
                            </span>
                        </button>
                        <div className="overflow-hidden">
                            {sampleData.contribution.map((item, index) => (
                                <div
                                    key={index}
                                    className="flex justify-between items-center px-[20px] py-2 pb-[10px] border-b text-sm"
                                >
                                    <span className="font-light text-muted-foreground">{item.label}</span>
                                    <span className="font-light text-muted-foreground">{item.value}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Deductions Section */}
                    <div className="mb-[10px]">
                        <button className="flex justify-between items-center bg-[#e5e7eb3b] p-[10px] w-full">
                            <span className="font-normal text-muted-foreground text-sm">Deductions</span>
                        </button>
                        <div className="overflow-hidden">
                            {sampleData.deductions.map((item, index) => (
                                <div
                                    key={index}
                                    className="flex justify-between items-center px-[20px] py-2 pb-[10px] border-b text-sm"
                                >
                                    <span className="font-light text-muted-foreground">{item.label}</span>
                                    <span className="font-light text-muted-foreground">₹ {item.value}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PayrollCtcSidebar;
